type Tone = "success" | "danger" | "warning" | "info" | "neutral";

interface StatusBadgeProps {
  tone: Tone;
  label: string;
}

const TONE_STYLES: Record<Tone, string> = {
  success: "bg-emerald-50 text-emerald-600 border-emerald-200",
  danger: "bg-red-50 text-red-600 border-red-200",
  warning: "bg-amber-50 text-amber-600 border-amber-200",
  info: "bg-blue-50 text-blue-600 border-blue-200",
  neutral: "bg-gray-50 text-gray-600 border-gray-200",
};

export const StatusBadge = ({ tone, label }: StatusBadgeProps) => {
  return (
    <span
      className={`inline-flex items-center text-xs font-medium px-2.5 py-1 rounded-full border ${TONE_STYLES[tone]}`}
    >
      {label}
    </span>
  );
};
